export default __webpack_public_path__ + "static/media/logo11.b97cdb88.png";